<div style="min-height: calc(100vh - 287px);">
  <section class="wrapper inventory-view">
    <saldo-page-header [parentHeaderText]="'Andmikud'" [headerText]="'Makseandmikud'" [actionBtnExist]="false"
                       [filterExist]="true" [(filterCollapsed)]="filterCollapsed"
                       [showCancelButton]="!filterCollapsed && checkIfFilterEmpty()"
                       (onRestFilter)="filterComponent.clearFilters()"></saldo-page-header>
    <saldo-inventory-filter #filterComponent [periodOptions]="periodOptions" [statusOptions]="statusOptions"
                            [collapsed]="filterCollapsed" [inventoryType]="inventoryType" [yearOptions]="yearOptions"
                            [filter]="refreshFilter" [lastUsedNameSearch]="lastUsedNameSearch" (show)="filter($event)"
                            (lastUsedPartnerNameSearch)="saveLastUsedNameSearch($event)"></saldo-inventory-filter>
    <saldo-inventory-table *ngIf="loaded;else spinner" [data]="list" [columns]="columns" [totalItems]="totalItems"
                           [title]="'Makseandmikud'" [templates]="actionTemplate" [statusOptions]="statusOptions"
                           (massChange)="massChange($event)" [isAdmin]="isAdministrator" [inventoryType]="inventoryType"
                           [isDomainUser]="atLeastOneDomainPermission"></saldo-inventory-table>
  </section>
</div>
<ng-template #actionTemplate let-row="row">
  <saldo-popover *ngIf="row.isEditableRemovable" [showDeleteLegend]="innerWidth >= screenWidth.MEDIUM"
                 [title]="'Makseandmiku andmete kustutamine'" [type]="'delete'" [popoverText]="getPopoverText(row)"
                 [deleteDetails]="row.makandId" (delete)="removePaymentInventory($event)"
                 deleteBtnClassName="danger"></saldo-popover>
  <a *ngIf="row.isViewable" (click)="goToView('view',row.makandId)">
    <i class="material-icons-outlined">visibility</i>
    <span *ngIf="innerWidth >= screenWidth.MEDIUM">Vaata</span>
  </a>
  <a *ngIf="row.isEditableRemovable" (click)="goToEdit('edit', row.makandId)">
    <i class="material-icons-outlined">edit</i>
    <span *ngIf="innerWidth >= screenWidth.MEDIUM">Muuda</span>
  </a>
  <a *ngIf="row.isAddable" (click)="goToAdd('add', row)">
    <i class="material-icons-outlined">add</i>
    <span *ngIf="innerWidth >= screenWidth.MEDIUM">Lisa</span>
  </a>
</ng-template>
<ng-template #spinner>
  <saldo-spinner></saldo-spinner>
</ng-template>
